
import { WDFormDropdown } from './wd-form-dropdown';

/**
	Note:
	This form can store objects as values, but it uses the labels to search.  This
	way it matches what a user would type.  what they see is the value expected
	*/
export class WDFormDropdownobject extends WDFormDropdown {

	constructor(opts)
	{
		opts.dropdown_type = 'object';
		super(opts);
	};

};

customElements.define('wd-form-dropdown-object',WDFormDropdownobject);
